export default __webpack_public_path__ + "static/media/upload-doc.67667159.svg";